import React from "react"
import PropTypes from "prop-types"

import ImageLoader from "@components/ImageLoader/ImageLoader"
import Button from "@components/Button/Button"

import { isDwebUrl } from "@lib/urlMatchUtility"

import ConditionalLink from "@wrappers/ConditionalLink/ConditionalLink"

import css from "./ErrorScreen.scss"

const ErrorScreen = ({
    col,
    isSmall,
    isFixed,
    imageUrl,
    imageAltText,
    header,
    description,
    ctaLabel,
    ctaHandler,
    slug,
}) => {
    return (
        <div className={`flexColumn alignCenter`}>
            <div className={`col-${col} flexColumn alignCenter`}>
                <ImageLoader
                    src={imageUrl}
                    alt={imageAltText}
                    className={`marginTop-8 ${
                        isFixed
                            ? isSmall
                                ? css.iconContainerSmall
                                : css.iconContainer
                            : css.iconContainerFull
                    }`}
                />
                <div className="l5SemiBold marginTop-16 textCenter">{header}</div>
                {description && (
                    <div className="bodyRegular textSecondary marginTop-8 textCenter">{description}</div>
                )}
            </div>
            {ctaLabel && (slug || ctaHandler) && (
                <ConditionalLink
                    to={slug}
                    onClick={() => ctaHandler?.(header, description)}
                    isExternal={slug && !isDwebUrl(slug)}
                    className={`col-6 marginTop-16`}
                >
                    <Button type="secondary" label={ctaLabel} />
                </ConditionalLink>
            )}
        </div>
    )
}

ErrorScreen.defaultProps = {
    isSmall: false,
    isFixed: true,
}

ErrorScreen.propTypes = {
    col: PropTypes.number.isRequired,
    isSmall: PropTypes.bool,
    isFixed: PropTypes.bool,
    imageUrl: PropTypes.string.isRequired,
    imageAltText: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    description: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaHandler: PropTypes.func,
    slug: PropTypes.string,
}

export default ErrorScreen
